import { useParams } from 'react-router-dom';
import { Col, Collapse, Form, Row } from 'antd';

import { Container, FetchImage, FieldByType, Loader } from 'components';

import { useGetRequest, useUserRole } from 'hooks';
import { getIsNew } from 'utils';

import { OfferDetails } from 'codegen';
import { RecursiveRequired } from 'types';

import { CollapseActions, handleInitOfferDetailsSuccess } from './CollapseActions';
import { DisplayOptions } from './DisplayOptions';
import { useFormValues, useSetFormValues } from './hooks';
import { genericFields, milesConfigFields } from './offerCollapseFormHelpers';

import { IOfferStore, offerStore } from '../../store';

const { Panel } = Collapse;
const { useForm } = Form;

export const OfferCollapses = () => {
  const imgId = offerStore((state) => state.imgId);
  const initialValues = offerStore((state) => state.initialValues);

  const { offerId } = useParams();
  const isNew = getIsNew(offerId);

  const [form] = useForm<RecursiveRequired<IOfferStore['initialValues']>>();

  const { loading } = useGetRequest<OfferDetails>({
    url: `/offers/details/${offerId}`,
    options: {
      ready: !isNew,
      refreshDeps: [offerId],
      onSuccess: handleInitOfferDetailsSuccess,
    },
  });

  useSetFormValues(form, initialValues);

  const {
    enNotFilled,
    frNotFilled,
    isParticipation,
    isSaveBtnDisabled,
  } = useFormValues(form);

  const { isAdmin } = useUserRole();

  return (
    <Loader isLoading={loading}>
      <Row gutter={24}>
        <Col xs={8} xxl={6}>
          <Container noIndents scrollable>
            <FetchImage
              alt='Offer'
              isNew={isNew}
              imgId={imgId}
              preview={false}
            />
          </Container>
        </Col>

        <Col xs={16} xxl={12}>
          <Form
            labelWrap
            name='offerForm'
            form={form}
            colon={false}
            disabled={!isAdmin}
            initialValues={initialValues}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <Collapse
              accordion={!isNew}
              defaultActiveKey={isNew ? ['1', '2', '3'] : '1'}
            >

              <Panel key='1' header='Generic Options'>
                <Row>
                  <Col xs={18} xl={16}>
                    {genericFields(isNew, (!!isParticipation || !isAdmin)).map((field) => (
                      <FieldByType
                        key={field.label as string}
                        field={field}
                      />
                    ))}
                  </Col>
                </Row>
              </Panel>

              <Panel
                forceRender
                key='2'
                header='Display Options'
              >
                <DisplayOptions
                  enNotFilled={enNotFilled}
                  frNotFilled={frNotFilled}
                />
              </Panel>

              <Panel
                forceRender
                key='3'
                header='Miles Configuration'
              >
                <Row>
                  <Col xs={18} xl={16}>
                    {milesConfigFields.map((field) => (
                      <FieldByType
                        key={field.label as string}
                        field={field}
                      />
                    ))}
                  </Col>
                </Row>
              </Panel>
            </Collapse>

            <CollapseActions
              form={form}
              isParticipation={isParticipation}
              isSaveBtnDisabled={isSaveBtnDisabled}
            />
          </Form>
        </Col>
      </Row>
    </Loader>
  );
};
